
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomSelect from "components/Common/custom-select";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomDatePicker from "common/CustomDatePicker";
import TableContainer from "components/Common/TableContainer";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { fetchEmployeeActivityReport, fetchEmployeeDropdownAutoList, fetchMyActivityReport, resetEmployeeReport } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import Loader from "common/pageLoader";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const EmployeeReportMyActivity = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    dropdownAutoList,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.EmployeeReportReducer?.employeeReport ?? [],
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],

    loading: state.EmployeeReportReducer?.loading,
    error: state.EmployeeReportReducer?.error,
    success: state.EmployeeReportReducer?.success,
  }));

  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

  

  useEffect(() => {
    dispatch(resetEmployeeReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchEmployeeDropdownAutoList(unitId))
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      employee: "",
      fromDate: "",
      toDate: "",
    },
    validationSchema: Yup.object({
      // employee: Yup.string().required("Employee is required"),
      fromDate: Yup.date().required("From Date is required"),
      toDate: Yup.date()
        .required("To Date is required")
        .min(Yup.ref("fromDate"), "To Date must be after From Date"),
    }),
    onSubmit: (values) => {
      // console.log("Form values:", values);
      const formData = new FormData();
      formData.append("emp_id", authDetails?.empid);
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append("unit_id", authDetails?.unit_id);
      dispatch(fetchMyActivityReport(formData));
    },
  });

  const columns = [ 
    { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    { Header: "Date", accessor: "punch_date" },
    { Header: "Shift Timings", accessor: "shift_timings" },
    { Header: "Punch In", accessor: "punch_in" },
    { Header: "Punch Out", accessor: "punch_out" },
    { Header: "Activity", accessor: "activity" },
    { Header: "Worked hours", accessor: "worked_hours" },
  ];

  const handleCancel = () => {
    formik.resetForm(); 
    dispatch(resetEmployeeReport()); 
  };

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Employee" breadcrumbItem="My Activity Report" />
        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row>

                <Col md={4}>
                  <Label>
                    From Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="fromDate"
                    value={formik.values.fromDate}
                    onChange={(val) => formik.setFieldValue("fromDate", val)}
                    onBlur={() => formik.setFieldTouched("fromDate", true)}
                  />
                  {formik.touched.fromDate && formik.errors.fromDate && (
                    <div className="text-danger mt-1">{formik.errors.fromDate}</div>
                  )}
                </Col>

                <Col md={4}>
                  <Label>
                    To Date <span className="text-danger">*</span>
                  </Label>
                  <CustomDatePicker
                    name="toDate"
                    value={formik.values.toDate}
                    onChange={(val) => formik.setFieldValue("toDate", val)}
                    onBlur={() => formik.setFieldTouched("toDate", true)}
                  />
                  {formik.touched.toDate && formik.errors.toDate && (
                    <div className="text-danger mt-1">{formik.errors.toDate}</div>
                  )}
                </Col>

                <Col className="d-flex mob-center align-items-center justify-content-end mt-4">
                  <Button type="submit" className="btn button-search me-2 ">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 " onClick={handleCancel}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {/* <Button type="button" className="btn button-print me-2 mt-2">
                    <i className="fas fa-print me-1" /> Print
                  </Button> */}
                  {/* <Button type="button" className="btn button-export mt-2">
                    <i className="fas fa-file-export me-1" /> Export
                  </Button> */}
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-0">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "My Activity Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "My Activity Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}                  
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            {/* <div className="mb-3">
              <h5 className="fw-bold text-primary fs-15">AES Technologies India Private Limited - Unit 1</h5>
            </div>
            <div className="monthtimesheet">
              <div className="timesheet-summary hoursheet p-2 mb-0 ">
                <div><p className=" mb-0"><strong >Employee Activity</strong></p></div>
              </div>
              <div className="timesheet-table"> */}
                <TableContainer
                  columns={columns}
                  data={employeeReport}
                  isGlobalFilter={true}
                  customPageSize={10}
                  // tableSorter={false}
                />
              {/* </div>
            </div> */}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EmployeeReportMyActivity;
